// extracted by mini-css-extract-plugin
export default {"layout":"PageLayout_layout__xXi1h","content":"PageLayout_content__Q5hpw","breadcrumbContainer":"PageLayout_breadcrumbContainer__pjmca"};